import { render, staticRenderFns } from "./MoodRating.vue?vue&type=template&id=6887550d&"
import script from "./MoodRating.vue?vue&type=script&lang=js&"
export * from "./MoodRating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports